import React from "react";
import Title from "../../atoms/title/title";
import { FaCalendarAlt } from "@react-icons/all-files/fa/FaCalendarAlt";
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import { Link } from "gatsby";

import "./featuredCards.scss";

export interface IFeaturedCards {
  titulo?: string;
  tarjetas: {
    tags: string[];
    description: string;
    imageURL: string;
    tiempo?: string;
    fecha?: string;
    link?: string;
  }[];
}

const FeaturedCards = (props: IFeaturedCards) => {
  const { titulo, tarjetas } = props;
  
  return (
    <section className="m-featured-cards">
      {titulo && <Title titulo={titulo} />}
      <div className="m-featured-cards__container">
        {tarjetas.map((card, key) => (
          <div className="m-featured-cards__card" key={key}>
            <div
              className="m-featured-cards__card-background"
              style={{
                backgroundImage: `url(${card.imageURL})`,
              }}
            ></div>
            <div className="m-featured-cards__card-content">
              <Link to={"/" + card.link.split("/", 1)}>
                <p className="m-featured-cards__card-category">
                  {card.tags?.join(", ")}
                </p>
              </Link>
              <p className="m-featured-cards__card-title">
                <Link to={card.link}>{card.description}</Link>
              </p>
              <div className="m-featured-cards__card-description">
                {card.fecha && (
                  <span className="m-featured-cards__card-label">
                    <FaCalendarAlt />
                    {card.fecha}
                  </span>
                )}
                {card.tiempo && (
                  <span className="m-featured-cards__card-label">
                    <FaClock />
                    {card.tiempo}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedCards;
